"use strict";

// todo выделено из containerEditor - нужно разделить на два: отдельно виджет dropdown, отдельно - уже работа со шрифтами и управление dropdown
// todo пока просто перенесено и организовано виджетом, требуется доработка
// todo вероятно, дропдаун реализовать с использованием jquery selectmenu
(function(){

$.widget("fotobook.fontFamilyBaseWidget", $.fotobook.containereditorbasecontrol, {

    $currentItem: null,
    $dropdown: null,

    getCurrentValue: function(){
        return parseInt(this.$currentItem.attr("data-value"), 10);
    },

    // разделитель шрифтов проекта и клипарт-темы
    _externalFonts_separator: [
        '<div class="clipart-theme-fonts">',
            '<div class="tb-dropdown-row">', t("photobook-js-fonts-from-external-themes"), '</div>',
        '</div>',
    ].join(""),

    /** темплейнт одного элента списка шрифта */
    _font_option_tpl: [
        '<div class="ajax-tooltip tb-dropdown-row" data-value="{id}" data-qtip-text="{name}">',
            '<div style="overflow:hidden">',
                '<img src="{preview_path}">',
            '</div>',
        '</div>'
    ].join(""),
    _renderFontsOptions: function (fonts){
        return fonts.map(function(font){
            return this._font_option_tpl.supplant({
                "id" : font.id,
                "name" : font.name.escapeAttr(),
                "preview_path" : Fotobook.createStorageUrl(font.preview_path).escapeAttr(),
            });
        }, this).join("");
    },

    _dropdownOptions: function(){
        return [
            this._renderFontsOptions(Fotobook.book.fonts),
            this._renderFontsOptions(Fotobook.store.getters['Fonts/getExternalFonts']),
        ].filter(function(value){
            return !!value;
        }).join(this._externalFonts_separator);
    },
    _tpl: [
        '<div class="current-item uniform-sprite-image"></div>',
        '<div class="tb-dropdown qtip-disabled auto-jsp" data-jsp-init="', JSON.stringify({"maintainPosition": true, "doNotShowHScroll": true, "autoReinitialise": true}).escapeAttr(), '" animate="fadeIn">',
            '{options}',
        '</div>',
    ].join(""),
    _renderControl: function(){
        return this._tpl.supplant({
            "options" : this._dropdownOptions(),
        });
    },

    _create: function(){
        var widget = this;

        this.element.addClass("tb-fonts uniform-sprite-image tb-list-item");
        this.element.html(this._renderControl());
        this.$currentItem = this.element.find(".current-item");
        this.$dropdown = this.element.find(".tb-dropdown");

        this.selectItem(this._getFontId());
        setTimeout(function(){
            widget._initEvents();
        }, 0);
        this._super();
    },
    _initEvents: function(){
        this._on(true, document, {
            "dragstart" : this.ondragstart,
            "click" : this.clickOutside,
        });
        this._on(false, window, {
            "resize" : this.updateDropDownPosition,
        });
    },
    selectItem: function(fontId){
        var $row = this.$dropdown.find(".tb-dropdown-row").filter("[data-value=" + fontId + "]").first();
        this.$dropdown.find(".tb-dropdown-row").not($row).removeClass("selected");
        $row.addClass("selected");
        this.updateCurrentItem();
    },
    updateCurrentItem: function(){
        var $selectedItem = this.element.find(".tb-dropdown-row.selected").first();
        if (!$selectedItem.length){
            $selectedItem = this.element.find(".tb-dropdown-row").first();
        }
        this.$currentItem.html($selectedItem.html());
        this.$currentItem.attr("data-value", $selectedItem.attr("data-value"));
    },
    _containerChanged: function(){
        this.selectItem(this._getFontId());
// нужно ли?
//        this.closeDropDown();
        this._super();
    },
    toggleDropDown: function(open){
        if (open === undefined){
            open = !this.element.hasClass("open-list");
        } else {
            open = !!open;
        }
        this.element.toggleClass("open-list", open);
        if (open){
            this.updateDropDownPosition();
        }
    },
    openDropDown: function(){
        this.toggleDropDown(true);
    },
    closeDropDown: function(){
        this.toggleDropDown(false);
    },

    clickOnCurrentItem: function(event){
        this.toggleDropDown();
    },
    clickOutside: function(event){
        if (!$(event.target).closest(this.element).length){
            this.closeDropDown();
        }
    },
    ondragstart: function(event){
        this.closeDropDown();
    },
    _processClick: function(event){
        var $target = $(event.target);
        if ($target[0] === this.element[0] || $target.closest(this.currentItem).length){
            this.clickOnCurrentItem();
            return;
        }
        var $row = $target.closest(".tb-dropdown-row:not(.ui-state-disabled)");
        if ($row.length){
            var fontId = parseInt($row.attr("data-value"), 10);
            if (fontId){
                if (fontId !== this.getCurrentValue()){
                    this.selectItem(fontId);
                    this.changeContainer();
                }
                this.closeDropDown();
            }
        }
        this._super();
    },
    _widgetMoved: function(){
        this.updateDropDownPosition();
    },
    updateDropDownPosition: function(){
        if (!this.element.hasClass("open-list")){
            return;
        }
        var instantrect = document.getElementById("instant").getBoundingClientRect(),
            jsp = this.$dropdown.data("jsp");

        if (!jsp) {
            this.$dropdown.removeClass("open-to-top").toggleClass("open-to-top", (this.$dropdown[0].getBoundingClientRect().bottom > instantrect.bottom));
        } else {
            // todo возможно ли переделать этот ад?
            var $parent = this.$dropdown.offsetParent(),
                $pane = this.$dropdown.find(".jspPane"),
                parentrect, innerHeight, height, h_to_top, h_to_bottom;

            if (!$parent.length || !$pane.length) {
                return;
            }

            innerHeight = $pane[0].scrollHeight;
            parentrect = $parent[0].getBoundingClientRect();

            h_to_top = Math.max(0, parentrect.top - instantrect.top);
            h_to_bottom = Math.max(0, Math.min(instantrect.bottom, $(window).height()) - parentrect.bottom);

            if (innerHeight > h_to_bottom && h_to_top > h_to_bottom) {
                height = h_to_top;
                this.$dropdown.addClass("open-to-top");
            } else {
                height = h_to_bottom;
                this.$dropdown.removeClass("open-to-top");
            }
            height = Math.min(innerHeight, height);
            $pane.closest(".jspContainer").css("height", height + "px");
        }
    },
});


// короткие тексты
$.widget("fotobook.plainTextFontFamilyWidget", $.fotobook.fontFamilyBaseWidget, {

    validateTextContainer: function(options){
        return Fotobook.textValidator.validate(this._getTextContent(), options);
    },
    _getTextContent: function(){
        return this.options.container.find(".text-content").first();
    },
    _getFontId: function(){
        var $textContent = this._getTextContent(),
            fontId = parseInt($textContent.attr("data-font-id"), 10);

        if (!fontId){
            fontId = parseInt($textContent.closest(".caption").attr("data-font-id"), 10);
        }
        return fontId;
    },
    changeContainer: function(){
        const $textArea = this._getTextContent();
        const font = Fotobook.store.getters['Fonts/getFontById'](this.getCurrentValue());

        Fotobook.store.commit('Fonts/loadFontByFamily', font.family);
        this.validateTextContainer({
            "confirm" : true,
            "family" : font.family,
        }).then(() => {
            $textArea.css("font-family", font.family);
            $textArea.attr("data-font-id", font.id);
            $textArea.trigger("keyup");
        }).catch(
            () => {}
        );
    },
});

// корешок
$.widget("fotobook.spineFontFamilyWidget", $.fotobook.plainTextFontFamilyWidget, {
    // !!! доработать
    _getTextContent: function(){
        return $(".spine-editor").find(".text-content");
    },
});


// Виджеты календарей
$.widget("fotobook.calendarFontFamilyBaseWidget", $.fotobook.fontFamilyBaseWidget, {
    attribute: null,
    _getFontId: function(){
        return parseInt(this.options.container.attr("data-" + this.attribute), 10);
    },
    changeContainer: function(){
        Fotobook.containers.calendar.changeAttribute(this.options.container, this.attribute, this.getCurrentValue());
    },
});

$.widget("fotobook.calendarMonthFontFamilyWidget", $.fotobook.calendarFontFamilyBaseWidget, {
    attribute: "month_font_id",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.headerIsVisible(this.options.container);
    },
});

$.widget("fotobook.calendarRegularFontFamilyWidget", $.fotobook.calendarFontFamilyBaseWidget, {
    attribute: "numbers_font_id",
});

$.widget("fotobook.calendarHolidayTitlesFontFamilyWidget", $.fotobook.calendarFontFamilyBaseWidget, {
    attribute: "numbers_title_font_id",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.holidayTitlesAreVisible();
    },
});

$.widget("fotobook.calendarDayNamesFontFamilyWidget", $.fotobook.calendarFontFamilyBaseWidget, {
    attribute: "day_name_font_id",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.dayNamesAreVisible(this.options.container);
    },
});

$.widget("fotobook.calendarWeekNumbersFontFamilyWidget", $.fotobook.calendarFontFamilyBaseWidget, {
    attribute: "week_numbers_font_id",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.weekNumbersAreVisible(this.options.container);
    },
});

})();
